export function formatHours(hours) {
  const formattedNumber = new Intl.NumberFormat('en-US').format(hours);
  return `${formattedNumber}h`;
}
